import React from 'react'
import './index.css'
import useDispatch from 'hooks/use-dispatch'
import logUtil from 'utils/log'
import Image from 'components/Image'
import FlexColumn from 'components/FlexColumn'
import Span from 'components/Span'
import View from 'components/View'
import QuickShopProductSidebarUseItWithProductSwatchPicker from 'containers/QuickShopProductSidebar/components/UseItWith/components/Product/SwatchPicker'
import updateSelectedUseItWithVariantIdProductAction from 'modules/product/redux/actions/update-selected-perfect-your-look-variant-id'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'
import getSelectedUseItWithVariantProductSelect from 'modules/product/redux/selectors/get-selected-perfect-your-look-variant'
import useSelector from 'hooks/use-selector'
import VerticalSeparator from 'components/VerticalSeparator'
import TextSemiBold from 'components/TextSemiBold'

import Flex from 'components/Flex'
import Button from 'components/Button'
import getDiscountDataSelectorProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-discount-data'
import getDiscountPercentageFromVariantInfoSelector from 'modules/variant/redux/selectors/get-discount-percentage-from-variant-info'
import PriceAndDiscountPrice from 'components/PriceAndDiscountPrice'
import B from 'components/B'

import getOptionValueProductVariantUtil from 'modules/product-variant/utils/get-option-value'
import handleClickQuickShopProductSidebarUseItWithProductAction from 'containers/QuickShopProductSidebar/components/UseItWith/components/Product/actions/handle-click'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'

const ANALYTICS_EVENT = {
  SHOW_PERFECT_YOUR_LOOK_PRODUCT: 'SHOW_PERFECT_YOUR_LOOK_PRODUCT'
}

const COLOR_OPTION = 'Color'

/**
 * @param props
 * @param {ProductVariantCollection} props.perfectYourLookVariant
 * @param {number[]} props.perfectYourLookVariantIds
 * @param {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarUseItWithProduct (props) {
  const {
    perfectYourLookVariant,
    perfectYourLookVariantIds,
    analyticEventPrefix
  } = props
  const dispatch = useDispatch()

  const selectedUseItWithVariant = useSelector(getSelectedUseItWithVariantProductSelect)
  const variantToUse = (
    selectedUseItWithVariant ||
    perfectYourLookVariant
  )

  const debugProps = {
    props,
    selectedUseItWithVariant,
    perfectYourLookVariant,
    variantToUse
  }
  logUtil('QuickShopProductSidebarUseItWithProduct').debug('debugProps=', debugProps)

  const logEvent = (event) => {
    logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event)
  }

  const handleMount = () => {
    if (!perfectYourLookVariant) {
      return
    }

    logEvent(ANALYTICS_EVENT.SHOW_PERFECT_YOUR_LOOK_PRODUCT)

    dispatch(
      updateSelectedUseItWithVariantIdProductAction(perfectYourLookVariant?.variant_id)
    )

    dispatch(
      loadByIdDeepProductVariantAction(
        perfectYourLookVariant?.variant_id
      )
    )
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  const priceStr = getPriceProductVariantUtil(perfectYourLookVariant)
  const price = priceStr
    ? parseFloat(priceStr)
    : null

  const variantId = (
    variantToUse?.variant_id
  )

  const handleClick = () => {
    dispatch(
      handleClickQuickShopProductSidebarUseItWithProductAction({
        analyticEventPrefix,
        debugProps,
        variantToUse,
        variantId
      })
    )
  }

  const discountPercentage = useSelector(
    getDiscountPercentageFromVariantInfoSelector({ variantId })
  )
  const isFullSize = isFullSizeVariantUtil(perfectYourLookVariant)
  const {
    discountPrice
  } = useSelector(
    getDiscountDataSelectorProductCollectionItemSelector({
      discountPercentage,
      isFullSize,
      price,
      productVariant: variantToUse
    })
  )

  const optionValue = getOptionValueProductVariantUtil(variantToUse)

  if (!perfectYourLookVariant) {
    return <></>
  }

  return (
    <Flex
      className='quick-shop-product-sidebar-perfect-your-look-product'
    >
      <Button
        className='quick-shop-product-sidebar-perfect-your-look-product-image'
        onClick={handleClick}
      >
        <Image
          src={variantToUse?.variant_image_url}
          alt={`${perfectYourLookVariant?.title} image`}
          shouldLazyLoad
        />
      </Button>

      <FlexColumn
        className='quick-shop-product-sidebar-perfect-your-look-product-content'
      >
        <Button
          className='quick-shop-product-sidebar-perfect-your-look-product-content-title-wrapper'
          onClick={handleClick}
        >
          <Span
            className='quick-shop-product-sidebar-perfect-your-look-product-content-title'
          >
            {perfectYourLookVariant?.title}
          </Span>
        </Button>

        <Span
          className='quick-shop-product-sidebar-perfect-your-look-product-content-price'
        >
          <B>
            <PriceAndDiscountPrice
              discountPrice={discountPrice}
              price={price}
            />
          </B>
        </Span>

        {
          !!optionValue && (
            <>
              <View className='quick-shop-product-sidebar-perfect-your-look-product-content-option'>
                <TextSemiBold>{COLOR_OPTION}</TextSemiBold>
                <VerticalSeparator />
                <Span className='quick-shop-product-sidebar-perfect-your-look-product-content-value'>
                  {optionValue}
                </Span>
              </View>

              <QuickShopProductSidebarUseItWithProductSwatchPicker
                perfectYourLookVariantIds={perfectYourLookVariantIds}
                analyticEventPrefix={analyticEventPrefix}
              />
            </>
          )
        }

      </FlexColumn>
    </Flex>
  )
}
